import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiAcademicCap, HiBookOpen, HiShieldCheck, HiBuildingLibrary, HiExclamationTriangle } from 'react-icons/hi2';
import SectionTitle from '../components/SectionTitle';
import InfoBox from '../components/InfoBox';
import TabGroup, { TabPanel } from '../components/TabGroup';

const EducationJustice = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      <SectionTitle level={1} icon={HiAcademicCap}>
        {t('educationJustice.title')}
      </SectionTitle>

      <TabGroup>
        {/* TAB 1: VOS DROITS */}
        <TabPanel tabId="rights">
          <section>
            <SectionTitle level={2} icon={HiShieldCheck}>
              {t('educationJustice.rightsTitle')}
            </SectionTitle>
            <div className="bg-teal-50 dark:bg-teal-900/20 border-l-4 border-teal-600 dark:border-teal-400 p-4 rounded-r-lg">
              <ul className="space-y-3">
                {t('educationJustice.rightsItems', { returnObjects: true }).map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1 font-bold">✓</span>
                    <span className="text-gray-900 dark:text-white font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <section>
            <SectionTitle level={2} icon={HiBookOpen}>
              {t('educationJustice.educationRightsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('educationJustice.educationRightsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiBuildingLibrary}>
              {t('educationJustice.justiceRightsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('educationJustice.justiceRightsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>
        </TabPanel>

        {/* TAB 2: DÉMARCHES */}
        <TabPanel tabId="procedures">
          <section>
            <SectionTitle level={2} icon={HiBookOpen}>
              {t('educationJustice.schoolTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('educationJustice.schoolItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiBuildingLibrary}>
              {t('educationJustice.courtTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('educationJustice.courtItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <InfoBox type="conseil" title={t('educationJustice.adviceTitle')}>
            <p>{t('educationJustice.adviceContent')}</p>
          </InfoBox>
        </TabPanel>

        {/* TAB 3: SI PROBLÈME */}
        <TabPanel tabId="problems">
          <section>
            <SectionTitle level={2} icon={HiShieldCheck}>
              {t('educationJustice.policeTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('educationJustice.policeItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiExclamationTriangle}>
              {t('educationJustice.problemsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('educationJustice.problemsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-orange-600 dark:text-orange-400 mr-2 mt-1">!</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <InfoBox type="danger" title={t('educationJustice.urgentTitle')}>
            <p>{t('educationJustice.urgentContent')}</p>
          </InfoBox>
        </TabPanel>
      </TabGroup>
    </div>
  );
};

export default EducationJustice;
